import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * The restaurant selected for the current counting flow. Persisted (not just in-memory) so
 * reloading the phone mid-count — closing the tab, the OS reclaiming the homescreen-standalone
 * webview — lands back on the same restaurant instead of the picker; the actual count state
 * itself lives server-side (GET .../count-sessions/current), this only remembers the selection.
 */
interface CountRestaurantState {
  restaurantId: number | null
  setRestaurantId: (id: number | null) => void
}

export const useCountRestaurantStore = create<CountRestaurantState>()(
  persist(
    (set) => ({
      restaurantId: null,
      setRestaurantId: (id) => set({ restaurantId: id }),
    }),
    { name: 'count-session-restaurant' },
  ),
)
